module.exports = __webpack_public_path__ + "img/208-palestine.dab5110b.svg";